import { PromotionSettingCard } from './PromotionSettingCard'
import { withPromotionSettingCard } from './withPromotionSettingCard'

const ConnectedPromotionSettingCard =
  withPromotionSettingCard(PromotionSettingCard)

export { ConnectedPromotionSettingCard as PromotionSettingCard }
